import { render, staticRenderFns } from "./ProductClassModal.vue?vue&type=template&id=3ca6697a&scoped=true&"
import script from "./ProductClassModal.vue?vue&type=script&lang=js&"
export * from "./ProductClassModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductClassModal.vue?vue&type=style&index=0&id=3ca6697a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6697a",
  null
  
)

export default component.exports